import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntersection } from 'react-use';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePdpSetStickyPriceRow from '../state/context/usePdpSetStickyPriceRow';
import PDPBreadCrumbs from '../PDPBreadCrumbs';
import PDPPriceSection from '../PDPPriceSection';

// Mobile counterpart of PDPStickySummaryBar, shown once the name section scrolls off the top
const PDPMobileStickySummaryBarInner = t0 => {
  const $ = _c(16);
  const {
    nameSection: t1
  } = t0;
  const nameSection = t1 === undefined ? null : t1;
  let t2;
  if ($[0] !== nameSection) {
    t2 = {
      current: nameSection
    };
    $[0] = nameSection;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      threshold: 0
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const nameSectionEntry = useIntersection(t2, t3);
  const isNameSectionAbove = !!nameSectionEntry && !nameSectionEntry.isIntersecting && nameSectionEntry.boundingClientRect.top < 0;
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const setStickyPriceRow = usePdpSetStickyPriceRow();
  const t4 = isNameSectionAbove ? setStickyPriceRow : undefined;
  const t5 = !isNameSectionAbove;
  let t6;
  if ($[3] !== isNameSectionAbove || $[4] !== t5) {
    t6 = classNames("fixed inset-x-0 top-0 z-[999] bg-white shadow-md transition-[opacity,visibility] ease-in lg:hidden", {
      "opacity-0 invisible pointer-events-none": t5,
      "opacity-100": isNameSectionAbove
    });
    $[3] = isNameSectionAbove;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PDPBreadCrumbs shortened={true} />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = basicDetails?.name;
  let t9;
  if ($[7] !== t8) {
    t9 = <div className="text-base font-bold text-gray">{t8}</div>;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <PDPPriceSection />;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t9) {
    t11 = <FixedWidthContainer className="!py-3">{t9}{t10}</FixedWidthContainer>;
    $[10] = t9;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t11 || $[13] !== t4 || $[14] !== t6) {
    t12 = <div ref={t4} data-xc="PDPMobileStickySummaryBar" className={t6}>{t7}{t11}</div>;
    $[12] = t11;
    $[13] = t4;
    $[14] = t6;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  return t12;
};
PDPMobileStickySummaryBarInner.propTypes = {
  // A DOM element; instanceOf(Element) would throw on the server
  nameSection: PropTypes.instanceOf(Object)
};

// Null fallback: a loader here would sit in normal flow and push the page down
const PDPMobileStickySummaryBar = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader fallback={null}><PDPMobileStickySummaryBarInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPMobileStickySummaryBar;